import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: "[clear-invalid-values]" })
export class ClearInvalidValuesDirective {

  constructor(
    private ngControl: NgControl
  ) { }

  @HostListener("focusout")
  onFocusout() {
      if(this.ngControl.control.invalid){
        this.ngControl.control.setValue(null);
      }
  }
} 



// WEBPACK FOOTER //
// ./src/app/pillar/common/directives/clear-invalid-values-directive.ts